type dataParams = {
  id: string
  name: string
  slug: string
  description?: string
  media?:
    | {
        url: string
      }
    | {
        url: string
      }[]
  province: {
    slug: string
  }
}
type ConnectifProduct = {
  name: string
  productDetailUrl: string
  productId: string
  unitPrice: number
  description?: string
  imageUrl?: string
}

const getUrl = (params: dataParams) => {
  if (params.media) {
    if (Array.isArray(params.media)) {
      return params.media[0].url
    } else {
      return params.media.url
    }
  }
}
const useToConnectifProduct = (params: dataParams): ConnectifProduct => {
  return {
    name: params.name,
    productDetailUrl: routes().cottageDetail(
      {
        slug: params.slug,
        province: params.province.slug,
      },
      true,
    ),
    productId: params.id,
    unitPrice: 0.1,
    description: params.description
      ? cleanHTMLTags(params.description)
      : undefined,
    imageUrl: params.media ? getUrl(params) : undefined,
  }
}

export default useToConnectifProduct
